module.exports = __webpack_public_path__ + "static/img/tiaojiu.949c7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tiaojiu.png
// module id = w5EQ
// module chunks = 1